<template>
  <modal
    title="Add User To Group"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div v-if="groups.length == 0" class="py-5">
      <p class="text-center text-sm">
        You currently have no groups!
        <span class="text-secondary-orange font-semibold">
          <router-link
            to="/settings/users-and-groups/new-group"
            class="text-secondary-orange"
            >Create Group</router-link
          >
        </span>
      </p>
    </div>
    <div v-else class="add-user-to-group-modal-content">
      <div class="form-content-wrapper">
        <div class="form-header">
          <p>Add user to selected groups</p>
        </div>
        <div class="form-dropdown">
          <label class="label">Groups</label> <br />
          <el-select
            v-model="selectedGroupId"
            @change="saveGroupInformation"
            placeholder="Select Group"
          >
            <el-option
              v-for="group in groups"
              :key="group.id"
              :label="group.name"
              :value="group.id"
            >
            </el-option>
          </el-select>
          <!-- <p class="pt-3">
            Selected:
            <span
              v-if="selectedGroupName.length > 0"
              class="selected-group-wrapper"
              >{{ selectedGroupName }}
              <span class="cursor-pointer pl-2" @click="removeSelectedGroup"
                >X</span
              >
            </span>
          </p> -->
        </div>
      </div>
      <div class="actions">
        <p
          class="font-semibold cursor-pointer"
          @click="closeModal"
        >
          Cancel
        </p>
        <primary-button buttonText="Add User" @click="addUserToGroup" :loading="addingUserToGroup" :disabled="disableButton"/>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/UI/Modal/index";
export default {
  components: {
    Modal,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    // groups: {
    //   type: Array,
    //   required: true,
    // },
    userId: {
      required: true,
    },
  },
  data() {
    return {
      selectedGroupId: "",
      selectedGroupName: "",
      addingUserToGroup: false,
      group: {},
      groups:[],
      payload:{
        groupId: 0,
        isAdmin: false,
        userId: ''
      }
    };
  },
  computed: {
    disableButton() {
      return this.shouldDisableButton(this.selectedGroupId);
    },
  },
  mounted() {
    this.getGroups()
  },
  methods: {
    async addUserToGroup() {
      this.addingUserToGroup = true;
      try {
        let response = await this.$_addUserToGroup(this.payload);
        console.log(response);
        this.generateToast("User successfully added to group!", "success");
        this.addingUserToGroup = false;
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.handleError(error);
        this.addingUserToGroup = false;
      }
    },
    saveGroupInformation() {
      // let selectedGroup = this.groups.filter((group) => {
      //   return group.id == this.selectedGroupId;
      // });
      // this.selectedGroupName = selectedGroup[0].selectedGroupName;
      this.payload.groupId = this.selectedGroupId;
      this.payload.userId = this.userId;
    },
    async getGroups(){
      try{
        let response = await this.$_getAllGroups();
        this.groups = response.data.groups
      }catch(error){
        this.handleError(error);
      }
    },
    closeModal() {
      this.$emit("close-modal");
    },
    removeSelectedGroup() {
      this.selectedGroupName = "";
      this.selectedGroupId = "";
    },
  },
};
</script>

<style scoped>
.add-user-to-group-modal-content {
  margin: 1rem 0;
}
.add-user-to-group-modal-content p,
.label {
  font-size: 0.95rem;
}
.form-dropdown {
  margin: 1rem 0;
}
.custom-select {
  width: 50%;
  display: block;
}
.actions {
  display: flex;
  justify-content: space-between;
  padding: 1.5rem 0;
}
.cancel-btn {
  color: #f57a4d;
}
.edit-btn {
  background: #f57a4d;
  color: #ffffff;
}
.selected-group-wrapper {
  display: inline-block;
  background: #0253b3;
  border-radius: 3px;
  padding: 0.5rem 0.75rem;
  color: #ffffff;
  font-weight: 500;
}
</style>
